module.exports = __webpack_public_path__ + "img/37.db85e512.png";